export default function BountyBadge({ amount, size = "md", testId }) {
    const formatted = `$${(amount / 1000).toFixed(0)}k`;
    const sizes = {
        sm: "px-3 py-1 text-xs",
        md: "px-4 py-1.5 text-sm",
        lg: "px-5 py-2 text-base",
    };
    return (
        <span
            data-testid={testId || `bounty-badge-${amount}`}
            className={`inline-flex items-center gap-2 rounded-full border ${sizes[size]} font-medium transition-all hover:shadow-[0_0_24px_rgba(201,169,110,0.35)]`}
            style={{
                borderColor: "rgba(201,169,110,0.4)",
                background: "rgba(201,169,110,0.10)",
                color: "var(--brand-accent, #C9A96E)",
                boxShadow: "0 0 12px rgba(201,169,110,0.15)",
                backdropFilter: "blur(8px)",
            }}
        >
            <span
                className="h-1.5 w-1.5 rounded-full"
                style={{ background: "var(--brand-accent, #C9A96E)" }}
            />
            <span className="caption">Bounty</span>
            <span className="font-serif text-base leading-none">{formatted}</span>
        </span>
    );
}
